<template>
  <div>
    <v-overlay v-if="isLoading">
      <v-progress-circular
        v-model="isLoading"
        color="#d13e7a"
        size="50"
        :indeterminate="true"
      ></v-progress-circular>
    </v-overlay>
    <PageTitle title="Shop Stock Details" />
    <v-container fluid class="lighten-12 content">
      <v-col cols="12" md="12" class="pa-3">
        <v-card class>
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in items" :key="item.tab">
              {{ item.tab }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.tab">
              <v-card v-if="item.tab === 'Shop Products'" class="mt-2">
                <v-container fluid>
                  <v-row>
                    <v-card-text class="pa-0">
                      <v-row>
                        <v-col cols="12" lg="3">
                          <v-autocomplete
                            hide-details="auto"
                            :items="shops"
                            :loading="loadingShops"
                            v-model="selectedShop"
                            item-text="name"
                            item-value="id"
                            label="Shop"
                            outlined
                            dense
                            @change="emitInput"
                            :search-input.sync="searchShop"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" lg="3">
                          <BrandAutoComplete
                            v-model="brand"
                            :clear="clearFilter"
                          >
                          </BrandAutoComplete>
                        </v-col>
                        <v-col cols="12" lg="3">
                          <CategoryAutoComplete
                            v-model="category"
                            :clear="clearFilter"
                          >
                          </CategoryAutoComplete>
                        </v-col>

                        <v-col cols="12" lg="2" sm="12">
                          <v-text-field
                            hide-details="auto"
                            v-model.lazy="search"
                            dense
                            outlined
                            hide-no-data
                            clearable
                            placeholder="Search"
                            append-icon="mdi-magnify"
                          >
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" lg="1" sm="12">
                          <TableHeaderFilter :columns="columns" />
                        </v-col>
                      </v-row>

                      <v-card-title class="d-flex justify-end">
                        <toggle-button
                          v-model="isView"
                          @change="goToViews"
                          :value="isView"
                          style="margin-right: 12px"
                          :width="75"
                          :labels="{ checked: 'Grid', unchecked: 'List' }"
                        ></toggle-button>

                        <v-btn
                          hidden
                          small
                          class="text-white btn_gray w-100 d-none d-sm-flex"
                          v-print="printQr"
                          >Print
                          <v-icon right dark> mdi-printer </v-icon>
                        </v-btn>
                        <!-- <v-btn hidden small class="
                            text-white
                            btn_gray
                            ml-5
                          " @click="clearFilters()">Clear <v-icon right dark> mdi-close </v-icon>
                        </v-btn> -->
                      </v-card-title>

                      <!-- <v-card-title class="d-flex justify-space-between"
                      > Purchase Total Price:- {{purchaseprice  | formatCurrency }}
                        <v-btn
                            hidden
                            small
                            class="text-white btn_gray w-100 d-none d-sm-flex"
                            v-print="printQr"
                        >Print <v-icon right dark> mdi-printer </v-icon></v-btn
                        ></v-card-title
                      >
                        <v-card-title  class="justify-left">
                       Selling Total Price:- {{sellingprice  | formatCurrency }}
                      </v-card-title> -->

                      <StockProductsTemplate
                        :datas="data"
                        :data="productDetails"
                        class="test1"
                        id="shopproducts"
                        :isShop="true"
                        :columns="columns"
                        style="display: none"
                      />

                      <Report
                        :rowvisble="rowvisble"
                        v-if="productDetails.length > 0 && isView"
                        :reportDatas="productDetails"
                        @updateUnitPrice="updateUnitPrice"
                      />

                      <v-simple-table fixed-header dense>
                        <template v-slot:default>
                          <div
                            v-if="productDetails.length == 0"
                            class="mt-16 container justify-center item-center"
                          >
                            <img
                              style="height: 200px"
                              src="../../assets/img/no-result.jpg"
                            />
                          </div>
                          <thead v-if="productDetails.length > 0 && !isView">
                            <tr>
                              <th
                                class="text-left"
                                v-if="col.show"
                                v-for="(col, index) in columns"
                                :key="index"
                              >
                                {{ col.text }}
                              </th>
                            </tr>
                          </thead>

                          <tbody v-if="!isView">
                            <tr
                              v-for="(item, index) in productDetails"
                              :key="index"
                            >
                              <td
                                colspan="9"
                                v-if="rowNumber == index"
                                style="text-align: center"
                              >
                                <b>Loading ...</b>
                              </td>
                              <td v-if="columns[0].show && rowNumber != index">
                                {{ index + 1 }}
                              </td>
                              <td v-if="columns[1].show && rowNumber != index">
                                {{ item.name }}
                              </td>
                              <td v-if="columns[2].show && rowNumber != index">
                                {{ item.brand }}
                              </td>
                              <td v-if="columns[3].show && rowNumber != index">
                                {{ item.category }}
                              </td>
                              <td v-if="columns[4].show && rowNumber != index">
                                {{ item.unit.name }}
                              </td>
                              <td v-if="columns[5].show && rowNumber != index">
                                <v-select
                                  v-if="item.units"
                                  :value="item.convertunit"
                                  :items="item.units"
                                  hide-details="auto"
                                  item-text="name"
                                  class="ma-2"
                                  style="width: 170px"
                                  item-value="id"
                                  label="Units"
                                  outlined
                                  dense
                                  :error-messages="errors"
                                >
                                  <template v-slot:item="{ item, attrs, on }">
                                    <v-list-item
                                      v-bind="attrs"
                                      v-on="on"
                                      @click="
                                        updateUnitPrice($event, index, item)
                                      "
                                    >
                                      <v-list-item-title
                                        :id="attrs['aria-labelledby']"
                                        v-text="item.name"
                                      >
                                      </v-list-item-title>
                                    </v-list-item>
                                  </template>
                                </v-select>
                                <div
                                  v-else
                                  style="
                                    text-align: center;
                                    font-size: 17px;
                                    font-weight: 1200;
                                  "
                                >
                                  <b> - </b>
                                </div>
                              </td>
                              <td v-if="columns[6].show && rowNumber != index">
                                {{ item.batch.batch }}
                              </td>

                              <td v-if="columns[7].show && rowNumber != index">
                                {{ item.selling_price }}
                              </td>
                              <td v-if="columns[8].show && rowNumber != index">
                                {{ item.quantity }}
                              </td>
                              <v-col
                                v-if="rowvisble && rowNumber != index"
                                sm="3"
                                class="global_search d-none d-md-flex"
                              >
                                <v-menu
                                  transition="slide-y-transition"
                                  bottom
                                  :nudge-width="50"
                                  content-class="my-menu"
                                  :close-on-content-click="false"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-ship>
                                      <v-icon
                                        color="orange darken-2"
                                        dark
                                        small
                                        v-on="on"
                                      >
                                        mdi-cash-check
                                      </v-icon>
                                    </v-ship>
                                  </template>
                                  <v-list>
                                    <v-list-item>
                                      <v-row>
                                        <v-col cols="12">
                                          <v-ship small>
                                            <v-tooltip v-model="show" bottom>
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  icon
                                                  v-bind="attrs"
                                                  v-on="on"
                                                >
                                                  <v-icon color="black" small>
                                                    mdi-information-outline
                                                  </v-icon>
                                                </v-btn>
                                              </template>
                                              <span>Purchased Price</span>
                                            </v-tooltip>
                                            {{ item.purchase_price }}
                                          </v-ship>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                    <v-list-item>
                                      <v-row>
                                        <v-col cols="12">
                                          <v-ship small>
                                            <v-tooltip v-model="show" bottom>
                                              <template
                                                v-slot:activator="{ on, attrs }"
                                              >
                                                <v-btn
                                                  icon
                                                  v-bind="attrs"
                                                  v-on="on"
                                                >
                                                  <v-icon color="black" small>
                                                    mdi-information-outline
                                                  </v-icon>
                                                </v-btn>
                                              </template>
                                              <span>Minimum Price</span>
                                            </v-tooltip>
                                            {{ item.min_price }}
                                          </v-ship>
                                        </v-col>
                                      </v-row>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-col>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-card-text>
                  </v-row>
                </v-container>
                <!-- Pagination Begin -->
                <Pagination
                  @paginationOptions="setPaginationOptions"
                  @response="setResponseData"
                  @getPageNumber="setPagenumber"
                  :url="ShopProductsURL"
                  :filterAction="true"
                  :filter="filterData"
                  ref="pagination"
                />
                <!-- Pagination End -->
              </v-card>

              <ProductWarehouse v-if="item.tab == 'Warehouse Products'" />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>

      <div class="d-flex justify-center align-center"></div>
      <!-- </v-row> -->
    </v-container>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import TableFilters from '@/components/base/TableFilters';
import StockProductsTemplate from '@/components/PrintTemplates/StockProductsTemplate';
import { Product } from '@/models/Product';
import ProductWarehouse from './ProductWarehouse';
import axios from '@/plugins/axios';
import Report from './Card/index.vue';
import CategoryAutoComplete from '@/components/base/CategoryAutoComplete';
import BrandAutoComplete from '@/components/base/BrandAutoComplete';
import Pagination from '../shared/components/pagination.vue';
import SearchAutoComplete from '@/components/base/SearchAutoComplete.vue';
function debounce(fn, delay) {
  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

export default {
  data: () => ({
    searchValueDelay: '',
    qrCodeInput: '',
    isInputFunctionRunning: false,
    shops: [],
    rowNumber: -1,
    products: [],
    data: {
      shop: null,
      type: 'Shop',
    },
    tab: 'Shop Products',
    items: [
      { tab: 'Shop Products', content: '' },
      { tab: 'Warehouse Products', content: 'this is credit tab' },
    ],
    isLoading: false,
    search: null,
    searchShop: null,
    rowvisble: true,
    isView: true,
    selectedShop: null,
    category: '',
    brand: '',
    productDetails: [],
    loadingShops: false,
    purchaseprice: 0,
    sellingprice: 0,
    clearFilter: false,
    columns: [
      {
        text: 'No',
        show: true,
      },
      {
        text: 'Name',
        show: true,
        disabled: true,
      },
      {
        text: 'Brand',
        show: true,
      },
      {
        text: 'Category',
        show: true,
      },
      {
        text: 'Basic Unit',
        show: true,
        disabled: true,
      },
      {
        text: 'Convert Unit',
        show: true,
        disabled: true,
      },
      {
        text: 'Batch',
        show: true,
        disabled: true,
      },

      {
        text: 'Selling Price',
        show: true,
        align: 'right',
      },
      {
        text: 'Purchase Price',
        show: true,
        align: 'right',
      },
      {
        text: 'Quantity',
        show: true,
        align: 'center',
      },
    ],
    filter: {
      shops: '',
      brand: '',
      category: '',
      query: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    ProductWarehouse,
    StockProductsTemplate,
    Report,
    CategoryAutoComplete,
    BrandAutoComplete,
    Pagination,
    SearchAutoComplete,
  },

  methods: {
    clearFilters() {
      this.clearFilter = !this.clearFilter;
      this.search = '';
      this.brand = '';
      this.category = '';
    },
    isView(item) {
      this.isView = item;
    },
    updateUnitPrice(newvalue, index, item, rowNumber) {
      this.rowNumber = index;
      let productid = this.productDetails[index].id;
      let batchid = this.productDetails[index].batch.id;
      let unitid = this.productDetails[index].unit.id;

      axios
        .get(
          `reports/shops/${this.selectedShop}/products/${productid}?batch=${batchid}&unit=${unitid}&convertUnit=${item.id}`,
        )
        .then((res) => {
          let self = this;
          self.productDetails[index].selling_price =
            res.data.data.selling_price;
          self.productDetails[index].quantity = res.data.data.quantity;
          self.productDetails[index].purchase_price =
            res.data.data.purchase_price;
          self.productDetails[index].convertunit = item;

          this.rowvisble = false;
          setTimeout(() => {
            this.rowvisble = true;
            this.rowNumber = -1;
          }, 10);
          self.products.map((p) => {
            p.available_stock = p.quantity;
          });
        })
        .catch((err) => {
          this.rowNumber = -1;
        });
    },
    sumField(array, filed) {
      let value = 0;
      array.forEach((element) => {
        value += parseInt(element[filed]);
      });
      return value;
    },

    async getAllShops(value) {
      await this.$store
        .dispatch('shop/GetShop', {})
        .then((res) => {
          this.selectedShop = 1;
          this.shops = res;
        })
        .catch((err) => {});
    },
    getShopByQuery(query = '') {
      this.loading = true;
      this.isLoading = true;
      this.$store
        .dispatch('shop/GetShop', {
          query: query,
          status: 'active',
        })
        .then((res) => {
          this.shops = res;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    emitInput() {
      this.$emit('input', this.selectedShop);
    },
    // Pagination
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    refreshData() {
      this.$refs.pagination.refreshData();
    },
    setResponseData(data) {
      this.products = data;

      this.productDetails = this.products;
      this.purchaseprice = this.sumField(this.productDetails, 'purchase_price');
      this.sellingprice = this.sumField(this.productDetails, 'selling_price');
      this.products.map((p) => {
        p.available_stock = p.quantity;
        p.basicunit = p.unit;
        p.convertunit = '';
      });
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
      this.loading = false;
    },
  },

  created() {
    this.getAllShops();
  },
  computed: {
    printQr() {
      return {
        id: 'shopproducts',
        popTitle: 'Product Details',
      };
    },

    filterData: function () {
      return {
        shops: this.selectedShop,
        brand: this.brand,
        category: this.category,
        query: this.searchValueDelay,
      };
    },
    ShopProductsURL: function () {
      return `reports/shops/${this.selectedShop}/products`;
    },
  },
  watch: {
    searchShop: {
      handler(val) {
        this.getShopByQuery(val);
      },
      deep: true,
    },
    search: debounce(function () {
      if (this.isInputFunctionRunning) {
        return;
      }
      this.isInputFunctionRunning = true;

      this.searchValueDelay = this.search;

      this.isInputFunctionRunning = false;
    }, 800),
  },
};
</script>
